import React, { Fragment, useRef, useState } from 'react';
import AppInput from '../AppInput';
import dynamic from 'next/dynamic';

// const FullEditor = dynamic(() => import('@/components/common/NewEditor'), { ssr: false });
import Select from '../Select';
// import DynamicSelect from '../dynamicSelect/dynamicSelect';
// import DynamicSelectSort from '../dynamicSelect/dynamicSelectSort';
import Uploader from '@/components/common/Uploader';

import Toggle from '../Toggle';
// import TagInput from '../TagInput';
import styles from './styles.module.css';
import AppTextArea from '../AppTextArea';
// import ShamsiDateTimePicker from '../ShamsiDateTimePicker';
import AppCheckBoxGroup from '../AppCheckBoxGroup';
import AppUpload from '../AppUpload';
import TagInput from '../TagInput';
// import AppUpload from '../AppUpload';
import DynamicSelectSort from '../dynamicSelect/dynamicSelectSort';
import ShamsiDateTimePicker from '../ShamsiDateTimePicker';

export default function FormItem({
  item,
  index,
  onChange,
  value,
}: {
  item?: any;
  index: number;
  onChange: (x: any, key: string) => void;
  value: any;
}) {
  const [focused, setFocused] = useState<string | number | null>();
  const editorRefs = useRef([]);

  console.log('itemis==', item, item?.showError, item?.addMode);

  return (
    <Fragment key={index}>
      {item?.type == 'input' && (
        <AppInput
          className={item?.className}
          extraWrapperClass={item?.extraWrapperClass}
          wrapper={item?.wrapper}
          prefix={item?.prefix}
          prefixClass={item?.prefixClass}
          affix={item?.affix}
          affixStyle={item?.affixStyle}
          onClickInput={item?.onClickInput}
          onChange={(e: { target: { value: string } }) => onChange(e.target.value, item?.key)}
          themeColor={item?.themeColor}
          affixWrapper={item?.affixWrapper}
          onClick={item?.onClick}
          onKeyDown={item?.onKeyDown ? item?.onKeyDown : null}
          onFocus={() => {
            setFocused(item?.name);
          }}
          onBlur={() => {
            setFocused(null);
          }}
          vertical={item?.vertical}
          showError={item?.showError}
          error={item?.error}
          value={value ? value : item?.value}
          type={item?.inputType}
          name={item?.name}
          placeholder={item?.placeholder}
          title={item?.title}
          // inputtitleclass={item?.inputtitleclass}
          showRemoveIcon={item?.showRemoveIcon}
          extraInfoStyle={item?.extraInfoStyle}
          extraInfo={item?.extraInfo}
          guide={item?.guide}
          inputType={item?.inputType}
          disabled={item.disabled}
          // onChange={(value) => onChange({ target: { name: item.name, value } })}
          // errModal={item?.errModal}
          // name={item?.name}
          // placeholder={item?.placeholder}
          // title={item?.title}
          // inputtitleclass={item?.inputtitleclass}
          // extraTitle={item?.extraTitle}
          // extraInfo={item?.extraInfo}
          // showExtraInfo={item?.showExtraInfo}
          // prefix={item?.prefix}
          // prefixClass={item?.prefixClass}
          // extraInfoStyle={`${item?.styleColor} ${styles.star} `}
          // className={`${item?.className}  ${
          //   focused != undefined && focused == item?.name && styles.inputFocused
          // }  ${item?.showError == true && styles.newHeight}`}
          // showError={item?.showError}
          // error={item?.error}
          // // onChange={(value) => onChange({ target: { name: item.name, value } })}
          // onChange={(e) => {
          //   onChange(e.target.value, item?.id, item?.type, item?.key);
          // }}
          // defaultFocused={false}
          // value={value ? value : item?.value}
          // wraperClassName={`${item?.wraperClassName}`}
          // extraButtonStyle={`${item?.extraButtonStyle}`}
          // onFocus={() => {
          //   setFocused(item?.name);
          // }}
          // onBlur={() => {
          //   setFocused();
          // }}
          // disabled={item.disabled}
          // extraErrorStyle={item.extraErrorStyle}
          // affix={item?.affix}
          // affixClass={item?.affixClass}
          // type={item?.inputType}
          // targetType={item?.targetType}
          // onKeyDown={item?.onKeyDown ? item?.onKeyDown : null}
        />
      )}
      {item?.type == 'textarea' && (
        <AppTextArea
          className={item?.className}
          extraWrapperClass={item?.extraWrapperClass}
          wrapper={item?.wrapper}
          prefix={item?.prefix}
          prefixClass={item?.prefixClass}
          affix={item?.affix}
          affixStyle={item?.affixStyle}
          onClickInput={item?.onClickInput}
          onChange={(e: { target: { value: string } }) => onChange(e.target.value, item?.key)}
          themeColor={item?.themeColor}
          affixWrapper={item?.affixWrapper}
          onClick={item?.onClick}
          onKeyDown={item?.onKeyDown ? item?.onKeyDown : undefined}
          onFocus={() => setFocused(item?.name)}
          onBlur={() => setFocused(null)}
          showError={item?.showError}
          error={item?.error}
          value={value ?? item?.value}
          name={item?.name}
          placeholder={item?.placeholder}
          title={item?.title}
          showRemoveIcon={item?.showRemoveIcon}
          extraInfoStyle={item?.extraInfoStyle}
          extraInfo={item?.extraInfo}
          guide={item?.guide}
          inputType={item?.inputType}
        />
      )}
      {/* {item?.type == 'editor' && (
        <div
          className={`flex flex-col justify-start items-start w-full h-auto formItem ${styles.selectWrapper}`}
        >
          <p className={`${item?.editorTitle} ${styles.editorTitle} formTitle`}>
            {item?.title}{' '}
            {item?.showExtraInfo && <span className={item?.styleColor}>{item?.extraInfo}</span>}
          </p>
          <FullEditor
            value={value ? value : item?.value}
            onChange={(html) => {
              onChange(html, item?.key);
            }}
            title={item?.title}
          />
        </div>
      )} */}
      {item?.type == 'toggle' && (
        <div className={`${styles.toggleContainer} formItem w-full ${item?.className}`} key={index}>
          <span className={`${styles.toggleText} formTitle`}>{item?.title} </span>
          <Toggle
            state={value ? value : item?.value}
            onClick={() => {
              onChange(value ? !value : !item?.value, item?.key);
            }}
          />
        </div>
      )}
      {item?.type == 'select' && (
        // <Select
        //   styleColor={item.styleColor}
        //   classBtnLi={item?.classBtnLi}
        //   classchildern={item?.classchildern}
        //   list={item?.list}
        //   fillFormFunction={(id) => {
        //     onChange(id, item?.key);
        //   }}
        //   value={value ? value : item?.value}
        //   placeholder={item?.placeholder}
        //   className={`${item?.className}`}
        //   showError={item?.showError}
        //   error={item?.error}
        //   title={item?.title}
        //   selectedButtonColor={item?.selectedButtonColor}
        //   extraInfoStyle={item?.extraInfoStyle}
        //   extraInfo={item?.extraInfo}
        //   guide={item?.guide}
        //   extraButtonStyle={item?.extraButtonStyle}
        // />
        <Select
          extraInfo={item.extraInfo}
          extraInfoStyle={item?.starColor}
          // styleColor={item.styleColor}
          classBtnLi={item?.classBtnLi}
          // classChildern={item?.classChildern}
          list={item?.list}
          fillFormFunction={(id) => {
            onChange(id, item?.key);
          }}
          value={value ? value : item?.value}
          placeholder={item?.placeholder}
          className={`${item?.className}`}
          showError={item?.showError}
          error={item?.error}
          title={item?.title}
          selectedButtonColor={item?.selectedButtonColor}
          // showSearch={item?.showSearch}
          // callBackSearchValue={(value:string |number) => item?.callBackSearchValue(value)}
          icon={item?.icon}
          extraButtonStyle={`${item?.extraButtonStyle}`}
          buttonContainerStyle={`${item?.buttonContainerStyle}`}
        />
      )}
      {/* {item?.type === 'myselect' && (
        <div className={`${item.classMain} ${styles.selectWrapper}`}>
          <div>
            <p className={`${item?.classTitle} ${styles.title}`}>
              {item?.title}
              {item?.extraInfo && <span className={item?.styleColor}>{item?.extraInfo}</span>}
            </p>
          </div>
          <DynamicSelect
            errModal={item?.errModal}
            classContainer={item?.classContainer}
            options={item?.list}
            value={value ? value : item?.value}
            placeholder={item?.placeholder}
            onSelect={(id) => {
              onChange(id, item?.id, item?.type, item?.key);
            }}
            onInputChange={(typedValue) => {
              const matchedOption = item?.list?.find(
                (opt) => (opt.title || opt.name) === typedValue || opt.value === typedValue,
              );
              if (matchedOption) {
                onChange(matchedOption.id, item?.id, item?.type, item?.key);
              } else {
                onChange(typedValue, item?.id, item?.type, item?.key);
              }
            }}
          />
          {item?.showError && <p className={styles.error}>{item?.error}</p>}
        </div>
      )}
      {item?.type === 'myselectSort' && (
        <>
          <div className={`${item.classMain} ${styles.selectWrapper}`}>
            <div>
              <p className={`${item?.classTitle} ${styles.title}`}>
                {item?.title}
                {item?.extraInfo && <span className={item?.styleColor}>{item?.extraInfo}</span>}
              </p>
            </div>
            <DynamicSelectSort
              item={item}
              errModal={item?.errModal}
              classContainer={item?.classContainer}
              options={item?.list}
              value={value ? value : item?.value}
              id={item?.id + item?.setId}
              placeholder={item?.placeholder}
              onSelect={(id) => {
                onChange(id, item?.id, item?.type, item?.key, null, 'select');
              }}
              onInputChange={(typedValue, type = 'search') => {
                onChange(null, item?.id, item?.type, item?.key, typedValue, type);
              }}
              showError={showError}
            />
            {item?.showError && <p className={styles.error}>{item?.error}</p>}
          </div>
        </>
      )} */}
      {item?.type === 'myselectSort' && (
        <>
          <DynamicSelectSort
            item={item}
            errModal={item?.errModal}
            classContainer={item?.classContainer}
            // options={item?.list}
            // value={value ? {...value, dynamicSelectTitle:
            //   item?.listTitleKey
            //   ?.map(m => value?.[m])            // collect all desired fields
            //   .filter(Boolean)              // remove empty or undefined ones
            //   .join(" - ")               // join with a dash separator
            // } : item?.value ? {...item?.value, dynamicSelectTitle:
            //   item?.listTitleKey
            //   ?.map(m => item?.value?.[m])            // collect all desired fields
            //   .filter(Boolean)              // remove empty or undefined ones
            //   .join(" - ")               // join with a dash separator

            // } : item?.value}
            propsValue={value ? value : item?.value}
            id={item?.id}
            placeholder={item?.placeholder}
            onSelect={(id?: string | number) => {
              onChange(id, item?.key);
            }}
            // apiCall={item?.apiCall}
            // listTitleKey={item?.listTitleKey}
            // searchkey={item?.searchkey}
            // apiParams={item?.apiParams}
            // getInitialList={item?.getInitialList}
            // localSearch={item?.localSearch}
            apiCategory={item?.apiCategory}
            showSelect={item?.showSelect}
            disabled={item?.disabled}
            extraInfo={item?.extraInfo}
          />
        </>
      )}
      {item?.type == 'multiselect' && (
        <TagInput
          initialSelected={item?.value ? item?.value : []}
          onChange={(value) => {
            onChange(value, item?.key);
          }}
          key={item?.key}
          apiCall={item?.apiCall}
          addApiCall={item?.addApiCall}
          item={item}
          extraInfoStyle={item?.extraInfoStyle}
          extraInfo={item?.extraInfo}
          guide={item?.guide}
          title={item?.title}
        />
        // <TagInput
        //   tagList={item?.list}
        //   values={String(value ? value : item?.value)?.split(',')}
        //   onChange={(ids) => {
        //     onChange(ids, item?.key);
        //   }}
        //   errModal={item?.errModal}
        //   item={item}
        //   showError={item?.showError}
        //   error={item?.error}
        //   title={item?.title}
        //   extraInfo={item?.extraInfo}
        //   styleColor={item?.styleColor}
        //   className={item?.className}
        //   disabled={item?.disabled}
        //   showSearch={item?.showSearch}
        // />
      )}
      {item?.type == 'datePicker' && (
        // <DatePickerComp
        //   startDate={item?.value || value ? new Date(value ? value : item?.value) : null}
        //   className={item?.className}
        //   onChange={(date) => {
        //     onChange(date, item?.key);
        //   }}
        //   topPlaceholderStyle={styles.placeholder}
        //   title={item?.title}
        //   item={item}
        //   showError={item?.showError}
        //   error={item?.error}
        //   key={index}
        // />
        <div
          className={`flex flex-col justify-end items-start w-full h-auto formItem ${styles.selectWrapper}  ${!item?.vertical && ''}`}
        >
          <p className={`${item?.editorTitle} ${styles.editorTitle} w-full formTitle`}>
            {item?.title}{' '}
            {item?.showExtraInfo && <span className={item?.styleColor}>{item?.extraInfo}</span>}
          </p>
          <ShamsiDateTimePicker
            title={item?.title}
            className={`${styles.datePicker} w-full ${item?.className}`}
            initialMiladi={item?.value}
            onChange={(miladi: any) => {
              console.log('miladi====', miladi);
              onChange(miladi, item?.key);
            }}
            showError={item?.showError}
            error={item?.error}
            key={index}
            disablePastDates={item?.disablePastDates}
          />
        </div>
      )}
      {item?.type == 'upload' && (
        <Uploader
          id={item?.id}
          headTitle={item?.title}
          showImg={item?.showImg}
          uploadedFile={item?.uploadedFile}
          onUploadComplete={(data) => onChange(data, item?.key)}
          children={item?.children}
          uploadType={item?.uploadType}
          buttonText={item?.buttonText}
          showError={item?.showError}
          error={item?.error}
        />
      )}
      {item?.type == 'checkbox' && (
        <AppCheckBoxGroup
          // id={item?.id}
          title={item?.title}
          // children={item?.children}
          showError={item?.showError}
          error={item?.error}
          className={item?.className}
          extraWrapperClass={item?.extraWrapperClass}
          wrapper={item?.wrapper}
          prefix={item?.prefix}
          prefixClass={item?.prefixClass}
          affix={item?.affix}
          affixStyle={item?.affixStyle}
          onChange={(list: { id?: string | number; title?: string }[]) => onChange(list, item?.key)}
          // themeColor={item?.themeColor}
          affixWrapper={item?.affixWrapper}
          value={value ? item?.value : []}
          // name={item?.name}
          // placeholder={item?.placeholder}
          showRemoveIcon={item?.showRemoveIcon}
          extraInfoStyle={item?.extraInfoStyle}
          extraInfo={item?.extraInfo}
          guide={item?.guide}
          inputType={item?.inputType}
          vertical={item?.vertical}
          multi={item?.multi}
        />
      )}
      {item?.type == 'uploadGallery' && (
        <AppUpload
          title={item?.title}
          state={item?.value}
          callBackDeleteItem={(x) => {
            // let newList = item?.value?.filter((x: { url: string | number }) => x.url !== item.url);
            //  setInfo({...info,galleryFiles:info?.galleryFiles?.filter((x) => x.id !== item.id)})
            item?.callBackDeleteItem(x);
          }}
          onUploadComplete={(data) =>
            //  setInfo({...info, galleryFiles:[...info?.galleryFiles,{...data.response.newFile}],error:{...info?.error, galleryFileIds:false}})
            item?.onUploadComplete(data)
          }
          modalKey={item?.modalKey}
          showError={item?.showError}
          error={item?.error}
          vertical={item?.vertical}
          uploadButton={item?.uploadButton}
          UploadButtonStyle={item?.UploadButtonStyle}
          uploadType={item?.uploadType}
          enableDragAndDrop={item?.enableDragAndDrop}
          buttonContainerClassName={item?.buttonContainerClassName}
        />
      )}
    </Fragment>
  );
}
